import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import FooterBoton from '../components/footer-boton';
import { fetchBlogPosts, formatDate } from '../services/blogService';
import './home.css';
import './blog.css';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPosts = async () => {
      try {
        setLoading(true);
        const blogPosts = await fetchBlogPosts();
        setPosts(blogPosts);
      } catch (error) {
        console.error('Error loading blog posts:', error);
        // Fallback to empty array on error
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    loadPosts();
  }, []);

  return (
    <div className='blog-container'>
      <Helmet>
        <title>
          Blog - Boton | Recursos sobre Contabilidad Autónoma con IA
        </title>
        <meta
          name='description'
          content='Mantente actualizado con las últimas tendencias en contabilidad automatizada, cumplimiento fiscal y tecnología financiera para empresas en Panamá.'
        />
        <meta
          property='og:title'
          content='Blog - Boton | Recursos sobre Contabilidad Autónoma con IA'
        />
        <meta
          property='og:description'
          content='Mantente actualizado con las últimas tendencias en contabilidad automatizada, cumplimiento fiscal y tecnología financiera para empresas en Panamá.'
        />
        <meta
          property='og:image'
          content='https://botonapp.com/Images/demo-1200w.png'
        />
        <meta property='og:url' content='https://botonapp.com/blog' />

        {/* Blog-specific structured data */}
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Blog',
            name: 'Blog de Boton',
            description:
              'Recursos y artículos sobre contabilidad automatizada con inteligencia artificial para empresas en Panamá.',
            url: 'https://botonapp.com/blog',
            publisher: {
              '@type': 'Organization',
              name: 'Boton',
              logo: {
                '@type': 'ImageObject',
                url: 'https://botonapp.com/boton_logo/boton-200h.png',
              },
            },
            inLanguage: 'es-ES',
          })}
        </script>
      </Helmet>

      {/* Header */}
      <header className='blog-header'>
        <div className='blog-header-container'>
          <Link to='/' className='blog-logo-link'>
            <img
              src='/boton_logo/boton-200h.png'
              alt='Boton Logo'
              className='blog-logo'
            />
          </Link>
          <nav className='blog-nav'>
            <Link to='/' className='blog-nav-link'>
              Inicio
            </Link>
            <Link to='/#howitworks' className='blog-nav-link'>
              Cómo funciona
            </Link>
            <Link to='/#planes' className='blog-nav-link'>
              Planes
            </Link>
            <a
              href='https://botonapp.com/login'
              target='_blank'
              rel='noreferrer noopener'
              className='blog-nav-link'
            >
              Log in
            </a>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className='blog-hero'>
        <div className='blog-hero-container'>
          <h1 className='blog-hero-title'>Blog de Boton</h1>
          <p className='blog-hero-subtitle'>
            Recursos, consejos y actualizaciones sobre inteligencia artificial,
            contabilidad automatizada, y tecnología financiera para empresas en
            Panamá.
          </p>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className='blog-posts'>
        <div className='blog-posts-container'>
          {loading ? (
            <div className='blog-loading'>
              <p>Cargando artículos...</p>
            </div>
          ) : (
            <div className='blog-posts-grid'>
              {posts.map((post) => (
                <article key={post.id} className='blog-post-card'>
                  <Link to={`/blog/${post.id}`} className='blog-post-link'>
                    <div className='blog-post-thumbnail'>
                      <img
                        src={post.thumbnail}
                        alt={post.title}
                        className='blog-post-image'
                      />
                    </div>
                    <div className='blog-post-content'>
                      <div className='blog-post-meta'>
                        <span className='blog-post-date'>
                          {formatDate(post.date)}
                        </span>
                        <span className='blog-post-author'>
                          por {post.author}
                        </span>
                      </div>
                      <h2 className='blog-post-title'>{post.title}</h2>
                      <p className='blog-post-excerpt'>{post.excerpt}</p>
                      <span className='blog-post-read-more'>Leer más →</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Demo Section */}
      <section className='home-demo2'>
        <div className='home-action'>
          <div className='home-heading4'>
            <span className='home-text360 title'>¿Quieres un demo?</span>
            <span className='home-text361'>
              En 30 minutos te mostramos lo que BOTON puede hacer por tu
              negocio.
            </span>
            <a
              href='https://calendly.com/d/cscj-pcy-82x'
              target='_blank'
              rel='noreferrer noopener'
              className='home-link21'
            >
              <div className='home-get-started9 template-button'>
                <span className='home-text362'>
                  <span>Agendar</span>
                  <br></br>
                </span>
              </div>
            </a>
          </div>
          <div className='home-images'>
            <img
              alt='image'
              src='/Images/demo-1200w.png'
              className='home-image3'
            />
          </div>
        </div>
      </section>

      <FooterBoton />
    </div>
  );
};

export default Blog;
